import Container from './Container'
import { ContainerType } from './ContainerType'
import Sticky from 'sticky-js'
import ResizeObserver from './ChangeObserver/ResizeObserver'

export default class StickyContainer extends Container {
  constructor () {
    super(ContainerType.STICKY, true)
  }

  style (bid, slot, media) {
    /* eslint-disable */
    const sticky = new Sticky('#' + slot.containerId())

    const resize = new ResizeObserver(null, () => sticky.update())

    slot.onDestroy(() => sticky.destroy())
  }
}
